export enum BreakdownDisplayMode {
  Remove = "remove",
  Strikethrough = "strikethrough",
}
